<template>
  <div>
    <Header />
    <router-view />
    <Footer />
    <div v-if="!cookieConsent" class="cookie-consent">
      <p>
        本網站使用 Cookie 來提升用戶體驗。請閱讀並同意
        <a href="/cookiepolicy">Cookie 政策</a>。
      </p>
      <button @click="acceptCookieConsent">我同意</button>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
export default {
  name: "DefaultLayout",
  components: { Header, Footer },
  data() {
    return {
      cookieConsent: false,
    };
  },
  created() {
    if (localStorage.getItem("cookieConsent")) {
      this.cookieConsent = true;
    }
  },
  methods: {
    acceptCookieConsent() {
      this.cookieConsent = true;
      localStorage.setItem("cookieConsent", "true");
    },
  },
};
</script>
